
import React, { useEffect } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import UserHeader from "./UserHeader";
import UserTable from "./UserTable";
import AddUserDialog from "./AddUserDialog";
import { useUserManagement } from "./hooks/useUserManagement";
import { useRolePermissions } from "@/hooks/useRolePermissions";
import { setSuperUserById } from "@/utils/setSuperUserUtil";
import { useUserFetch } from "./hooks/useUserFetch"; // Import the useUserFetch hook

const UserManager = () => {
  const { isSuper } = useRolePermissions();
  const { 
    handleAddUser,
    handleDeleteUser, 
    handleToggleAdminRole, 
    handleToggleUserActive, 
    handleChangeUserRole, 
    isSubmitting 
  } = useUserManagement();
  
  const [isAddDialogOpen, setIsAddDialogOpen] = React.useState(false);
  const [newUserEmail, setNewUserEmail] = React.useState("");
  const [newUserPassword, setNewUserPassword] = React.useState("");
  const [showAllUsers, setShowAllUsers] = React.useState(false);
  
  // Use the useUserFetch hook to get users data
  const { users, loading, isServiceRoleAvailable, fetchUsers } = useUserFetch(showAllUsers, null);

  // Set the specified user as the super user when the component loads
  useEffect(() => {
    const setupSuperUser = async () => {
      const userId = 'c717fbe7-010c-4baa-8eb1-fbc745e54f40';
      const email = 'avidandor@gmail.com';
      
      console.log("Setting up super user:", email);
      await setSuperUserById(userId, email);
      
      // Refresh the users list after setting super user
      fetchUsers();
    };
    
    setupSuperUser();
  }, []);

  // Handle adding a new user - wrapper function to match expected signature
  const onAddUser = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newUserEmail || !newUserPassword) {
      return;
    }

    try {
      await handleAddUser(e);
      setNewUserEmail("");
      setNewUserPassword("");
      setIsAddDialogOpen(false);
      fetchUsers(); // Refresh user list
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  return (
    <div className="space-y-6">
      <UserHeader 
        onRefresh={fetchUsers}
        onAddUser={() => setIsAddDialogOpen(true)}
        isServiceRoleAvailable={isServiceRoleAvailable}
      />
      
      {isSuper && (
        <div className="flex items-center space-x-2 justify-end">
          <Switch 
            id="show-all-users" 
            checked={showAllUsers}
            onCheckedChange={setShowAllUsers}
          />
          <Label htmlFor="show-all-users">
            הצג את כל המשתמשים במערכת
          </Label>
        </div>
      )}
      
      <UserTable 
        users={users}
        loading={loading}
        handleToggleAdminRole={handleToggleAdminRole}
        handleDeleteUser={handleDeleteUser}
        handleToggleUserActive={handleToggleUserActive}
        handleChangeUserRole={handleChangeUserRole}
        canChangeRoles={isSuper}
      />

      <AddUserDialog 
        isOpen={isAddDialogOpen}
        onOpenChange={setIsAddDialogOpen}
        newUserEmail={newUserEmail}
        setNewUserEmail={setNewUserEmail}
        newUserPassword={newUserPassword}
        setNewUserPassword={setNewUserPassword}
        handleAddUser={onAddUser}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default UserManager;
